import React, { lazy, Component } from 'react';
import logo from "../../common/media/cc_logo_grey.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import {useMediaQuery} from "react-responsive";

// lazy() must be defined at module level — calling it inside a component creates a new type on every render,
// causing React to constantly unmount/remount and re-request chunks (leading to ChunkLoadError timeouts)
const ImpactSectionLazy = lazy(() => import('./sections/ImpactSection'));
const TogetherForTheFutureSectionLazy = lazy(() => import('./sections/TogetherForTheFutureSection'));
// const QuotesSectionLazy = lazy(() => import('./sections/QuotesSection'));
const ProjectsSectionLazy = lazy(() => import('./sections/ProjectsSection'));
const FAQSectionLazy = lazy(() => import('./sections/FAQSection'));
const FooterSectionLazy = lazy(() => import('./sections/FooterSection'));

class ChunkErrorBoundary extends Component {
    state = { failed: false };
    static getDerivedStateFromError() { return { failed: true }; }
    render() { return this.state.failed ? null : this.props.children; }
}

const LandingPage = ({ merchantCode, fetchedImpact, projects, lang }) => {
    const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

    return (
        <div>
            <div style={{display: "flex", justifyContent: "space-between"}}>
                <div className="mobile-hide h-100px bg-white h-align px-5">
                    <img height='50px' src="https://res.cloudinary.com/carbonclick/image/upload/v1686818432/Enterprise/Etihad/etihad-airways-logo-wo-cw_p2gbva.svg" />
                </div>
                <div className="mobile-hide h-100px bg-white h-align px-5">
                    <img height='50px' src="https://res.cloudinary.com/carbonclick/image/upload/v1688642102/Merchant%20Portal/new-logo_j8usbf.svg" />
                </div>
            </div>
            <div className="h-85vh px-5 w-100 position-relative hero-img header-img-cover vertical-align-parent" >
                <div className="color-white text-align-start vertical-align">
                    <div className="mobile-hide">
                        <h1 className="color-secondary mb-4 text-shadow mt-0 etihad-bold">Go the extra mile</h1>
                        <h4 style={{maxWidth: '1100px'}} className="color-secondary mb-5 text-shadow font-etihad">By estimating and offsetting emissions, you can choose to support climate projects, certified to reduce a small amount of atmospheric carbon emissions*.</h4>
                        <div className="mobile-hide mb-5">
                            <div className="d-flex gap-8" style={{ alignItems: 'baseline' }}>
                                <a className="button-transformation no-color-btn btn-primary font-etihad" href="#FlightCalculator">Contribute now</a>
                            </div>
                        </div>
                        <h6 style={{maxWidth: '1100px'}} className="color-secondary mb-5 text-shadow font-etihad">*Disclaimer: The projects are certified by third party carbon registries such as Gold Standard or VCS (Verified Carbon Standard), have passed CarbonClick’s <a style={{color: '#BD8B13'}} href='https://www.carbonclick.com/news-views/how-we-assess-projects-our-7-point-impact-check'>7-Point Impact Check</a> and are audited annually. Offsetting emissions will not directly reduce your flying footprint.</h6>
                    </div>
                    <div className="mobile-show text-center">
                        <h2 className="color-secondary mb-4 text-shadow mt-0 font-etihad font-bold header-text">Go the extra mile</h2>
                        <h5 className="color-secondary mb-3 text-shadow font-etihad">By estimating and offsetting emissions, you can choose to support climate projects, certified to reduce a small amount of atmospheric carbon emissions*.</h5>
                        <a className="button-transformation mb-2 no-color-btn font-bold font-etihad btn-primary" href="#FlightCalculatorDummy">Contribute now</a>
                        <h6 style={{fontSize: '12px'}} className="color-secondary mb-5 text-shadow font-etihad">*Disclaimer: The projects are certified by third party carbon registries such as Gold Standard or VCS (Verified Carbon Standard), have passed CarbonClick’s <a style={{color: '#BD8B13'}} href='https://www.carbonclick.com/news-views/how-we-assess-projects-our-7-point-impact-check'>7-Point Impact Check</a> and are audited annually. Offsetting emissions will not directly reduce your flying footprint.</h6>
                    </div>
                    <div style={{justifyContent: 'right'}} className='mobile-hide powered-by d-flex'>
                        <h5 className="color-secondary margin-inline-end-2 m-0 font-etihad">Powered by</h5>
                        <div style={{marginTop: '-3px'}}>
                            <a target="_blank" href="https://www.carbonclick.com/">
                                <img style={{ height: 24 }} src={logo} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className='arrow-container fade-in'>
                    <a href="#content">
                        <img width='60px' height='50px' src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,c_scale,h_50,w_60/e_colorize,co_white/v1661168019/Enterprise/Etihad/down-arrow_dtvbk5.png' />
                    </a>
                </div>
            </div>
            <div className="mobile-show">
                <div className="bg-main-light p-3 text-center">
                    <div className="d-flex w-fit center powered-by-container">
                        <h5 className="color-secondary margin-inline-end-2 font-bold m-0 font-etihad">Powered by</h5>
                        <div style={{marginTop: '-8px'}}>
                        <a target="_blank" href="https://www.carbonclick.com/">
                            <img style={{ height: 26 }} src={logo} />
                        </a>
                        </div>
                    </div>
                </div>
            </div>

            <ChunkErrorBoundary>
                <React.Suspense fallback={<div/>}>
                    <ImpactSectionLazy fetchedImpact={fetchedImpact}/>
                </React.Suspense>
            </ChunkErrorBoundary>

            <div className="bg-white pattern-1 py-5 img-contain" id="FlightCalculator" style={{backgroundRepeat: "no-repeat", backgroundPosition: "left"}}>
                <div className="container mobile-p-0">
                    <div className="center shadow-lg flight-calculator-wrapper">
                        <div id="FlightCalculatorDummy"/>
                        <FlightCalculator merchantCode={merchantCode} />
                    </div>
                </div>
            </div>

            <ChunkErrorBoundary>
                <React.Suspense fallback={<div/>}>
                    <TogetherForTheFutureSectionLazy/>
                </React.Suspense>
            </ChunkErrorBoundary>


            {/*<React.Suspense fallback={<div/>}>*/}
            {/*    <QuotesSectionLazy/>*/}
            {/*</React.Suspense>*/}


            <ChunkErrorBoundary>
                <React.Suspense fallback={<div/>}>
                    <ProjectsSectionLazy isHorizontal={!isMobile} projects={projects} lang={lang} />
                </React.Suspense>
            </ChunkErrorBoundary>


            <ChunkErrorBoundary>
                <React.Suspense fallback={<div/>}>
                    <FAQSectionLazy/>
                </React.Suspense>
            </ChunkErrorBoundary>

            <div className="w-100 py-3 font-etihad footer translate-dynamic">
                <div className="etihad-container py-3">
                    <h6 className="color-secondary mb-2 text-shadow font-etihad">Disclaimers: Etihad does not claim or report any carbon offsets purchased by our guests, whether via this site, CarbonClick Traveller, Etihad Reward Shop or Etihad.com Booking Flow (or anywhere it may offer this solution) against any compliance framework, scheme or roadmap. Carbon Offset purchases do not improve the environmental credentials of the airline nor directly reduce the impact of a flight on the environment. Carbon offsetting is an option to contribute to climate projects that have met the criteria of third-party registries such as Gold Standard or VCS to reduce a small amount of atmospheric carbon emissions. The projects have been hand-picked by CarbonClick, passed their <a style={{color: '#BD8B13'}} href={'https://www.carbonclick.com/news-views/how-we-assess-projects-our-7-point-impact-check'}>7-Point Impact Check</a> and are audited regularly. Projects certified by VCS (Verified Carbon Standard) are audited every 1-3 years, depending on the project type. Since the environmental impact of flying cannot currently be avoided, a contribution to such projects can be encouraged to create a positive effect elsewhere. The intention to 'balance' environmental impacts should not be assumed to neutralise or erase any emission or impact from Etihad's operations.</h6>
                    <h6 className="color-secondary mb-1 text-shadow font-etihad">When travelling with Etihad and engaging in 'environmental activities', such as supporting the Etihad Mangrove Forest or an offset with CarbonClick will not make Etihad's operations more sustainable. Etihad provides these options to travellers who wish to customise their experience with ecologically focused ancillaries, but customers should be aware that this does not make travelling on Etihad Airways a more sustainable option over our competitors. The initiatives we undertake as an airline in our Sustainability strategy are shared mitigation options available to all airlines, and where Etihad is supporting the development of specific solutions, we are committed to making our research and findings available for the entire industry.</h6>
                </div>
            </div>

            {/*<div className="bg-green-light py-6">
                <div className="container text-center">
                    <div className="mb-5 center mw-600px">
                        <h2 className="font-light">Make a difference in fighting climate change</h2>
                        <p>Purchase a subscription to make an ongoing, traceable difference. We&apos;ll show you how your positive impacts grow each month.</p>
                    </div>

                    country && <PlansList
                        selectedPlan={selectedPlan}
                        onSelectedPlanChange={setSelectedPlan}
                        planChosen={planChosen}
                        country={country}
                        setLocationModalVisible={setShowModal}
                    />}
                </div>
            </div>*/}

            <ChunkErrorBoundary>
                <React.Suspense fallback={<div/>}>
                    <FooterSectionLazy/>
                </React.Suspense>
            </ChunkErrorBoundary>
        </div>
    )
}


export default LandingPage;